/**
 * 頁面應用服務
 * 處理頁面相關的應用層邏輯，協調領域層和基礎設施層
 */
import { Page } from "@/domain/models/page";
import { pageService } from "@/domain/services/pageService";
import { contextService, UserContext } from "@/domain/services/contextService";

/**
 * 頁面應用服務
 * 協調領域層和基礎設施層，為 UI 層提供頁面相關功能
 */
export const usePageService = {
  async getUserContext(): Promise<UserContext> {
    const context = await contextService.getContext();
    return context;
  },


  /**
   * 獲取專案的所有頁面
   * @param projectId 專案 ID
   * @returns 頁面列表
   */
  async getProjectPages(projectId: string): Promise<Page[]> {
    return await pageService.getProjectPages(projectId);
  },

  /**
   * 獲取頁面訊息
   * @param projectId 專案 ID
   * @param pageId 頁面 ID
   * @returns 頁面訊息
   */
  async getPageById(projectId: string, pageId: string): Promise<Page> {
    return await pageService.getPageById(projectId, pageId);
  },
};
